/**
 * Returns the human-readable label for a DRIMS role id.
 * Uses USER_ROLES from ApplicationConstant. Fallback: String(roleId) or "Unknown".
 *
 * @param {number|null|undefined} roleId
 * @returns {string}
 */
import { USER_ROLES } from 'constants/ApplicationConstant';

function getRoleLabel(roleId) {
  if (roleId === null || roleId === undefined) {
    return 'Unknown';
  }
  const found = USER_ROLES.find((r) => r.value === roleId);
  return found ? found.label : String(roleId);
}

export default getRoleLabel;
